import axios from "axios";

/* 🔒 Use REACT_APP_API_URL env var so staging/CI don't hit production */
const BASE_URL =
  process.env.REACT_APP_API_URL ||
  (window.location.hostname === "localhost"
    ? "http://localhost:5000/api"
    : "https://herambaayurveda.in/api");

const api = axios.create({ baseURL: BASE_URL });

/* ─── Shared helper — avoids duplication between request & response interceptors ─── */
function isAdminRoute(url = "") {
  return (
    url.includes("/requests")         ||
    url.includes("/admin/")           ||
    url.includes("/mrd/")             ||
    url.includes("/settings")         ||
    url.includes("/employees")        ||
    url.includes("/content")          ||
    url.includes("/media")            ||
    url.includes("/doctor-profiles")  ||
    url.includes("/daily-posts")      ||
    url.includes("/seasonal-regimen") ||
    url.includes("/upload")           ||
    url.includes("/opd-admin")        ||
    url.includes("/chatbot/admin")
  );
}

/* ─────────────── REQUEST ─────────────── */
api.interceptors.request.use((config) => {
  const doctorToken = sessionStorage.getItem("doctorToken");
  const adminToken  = sessionStorage.getItem("adminToken");
  const url = config.url || "";

  config.headers = config.headers || {};

  if (adminToken && !url.includes("/admin/login") && isAdminRoute(url)) {
    config.headers.Authorization = `Bearer ${adminToken}`;
    return config;
  }

  if (doctorToken && !url.includes("/doctor/login")) {
    config.headers.Authorization = `Bearer ${doctorToken}`;
    return config;
  }

  if (adminToken && !url.includes("/admin/login")) {
    config.headers.Authorization = `Bearer ${adminToken}`;
    return config;
  }

  return config;
}, (error) => Promise.reject(error));

/* ─────────────── RESPONSE ─────────────── */
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const url = error.config?.url || "";

    if (url.includes("/doctor/login") || url.includes("/admin/login")) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401) {
      if (!isAdminRoute(url) && sessionStorage.getItem("doctorToken")) {
        sessionStorage.removeItem("doctorToken");
        sessionStorage.removeItem("doctorLoginDay");
        sessionStorage.removeItem("doctorUser");
        window.location.href = "/staff-portal/login";
      } else if (sessionStorage.getItem("adminToken")) {
        sessionStorage.removeItem("adminToken");
        sessionStorage.removeItem("adminUser");
        window.location.href = "/clinic-management/signin";
      }
    }

    return Promise.reject(error);
  }
);

export default api;